/**
 * React hook for accessing PostHog service
 */

import { useMemo } from 'react';
import { PosthogService } from '../services/posthog';

export const usePosthog = () => {
  const posthog = useMemo(() => PosthogService.getInstance(), []);
  return posthog;
};
